<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">富阳餐厨垃圾处置智能工厂</div>
        <!-- <div class="case_time">
					<img src="../../assets/images/developerCommunity/dev_time.png" alt="">
					<span>2020/06/12</span>
				</div> -->
        <hr>
      </div>
      <div class="case_detail">
        <div class="model">
          <div class="model_title">【企业介绍】</div>
          <div class="section">
            浙江杭州富阳循环经济产业园餐厨/厨余垃圾处置智能工厂项目是国家十三五规划项目，由杭州滨和集团投资建设，天人环境为主体工艺EPC总承包商。作为浙江省的重点示范项目，杭州滨和集团致力于将该项目打造成为餐厨/厨余处置智能工厂示范、工业旅游景点和科普教育基地。
          </div>
          <div class="section">
            <video style="width: 100%" muted loop controls>
              <!-- <source type="video/mp4" src="@/assets/images/fyjs.mp4" /> -->
              <!-- <source type="video/mp4" src="@/assets/images/fyjs1.mp4" /> -->
            </video>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div class="section">
            <img src="../../assets/images/detail_fy01.png" alt="">
          </div>
          <div class="section">
            <img src="../../assets/images/detail_fy02.png" alt="">
          </div>
          <div class="section">
            该项目2020年5月开工建设，2020年12月餐厨垃圾车进场卸料，历时7个月，实现了可视化、智能化、平台化的运营管理，让智能工厂从一个虚拟概念，真真切切地落到实处，看到了其增效成果和未来巨大的发展潜力，用实际行动响应杭州提出的打造全国数字经济第一城的号召。
            该项目设计规模日处理300吨餐厨/厨余垃圾（餐厨150t/d+厨余150t/d），主工艺流程为餐饮、厨余垃圾预处理→中温CSTR湿式厌氧发酵+固液分离→生物脱硫→沼气发电。项目资源化利用后，年发电量700万度、年产工业油脂3000吨，建有两条餐厨垃圾处理生产线和一条厨余垃圾无害化处理生产线，可实现项目减量化、无害化、资源化处置。
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            <img src="../../assets/images/detail_fy03.png" alt="">
          </div>
          <div class="section">
            1、预处理工艺设计思路有突破性创新，实现为业主降低项目总投资15%、减少能耗20%；
          </div>
          <div class="section">
            2、本项目是智能工厂的最本质特征是：目前已实现综合增效10%（计划30%）；
          </div>
          <div class="section">
            3、采用E平台+微平台智能工厂的核心技术，由模型池按需随时下发最新增效模型，实现持续增效。
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CaseZjnxhjjDetail',
  data () {
    return {
      detailId: this.$route.params.id,
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.init()
  },
  methods: {
    init () {
      console.log(this.detailId)
    }
  }
}
</script>

<style lang="scss">
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #FFFFFF;
}

.case_main {

  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;

    img {
      width: 100%;
    }

    .model {
      margin-top: 0.2rem;

      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }

      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZjnxhjjDetail.vue